<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      GDPR-indstillinger
      @if (isCleanerDisabled    ) {
        <mat-icon
          matTooltip="Anonymisering deaktiveret (journaliseringssystem)."
          class="ml-3 cleaner-disabled-text"
        >warning</mat-icon>
      }
    </mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="settings-view">
      <dl fxFlex="30" class="settings-list">
        <dt [ngClass]="{ 'cleaner-disabled-text': isCleanerDisabled }">
          Journaliseringssystem
        </dt>
        <dd [ngClass]="{ 'cleaner-disabled-text': isCleanerDisabled }">
          <span class="cleaner_disabled_value">{{value.cleaner_disabled ? 'Ja' : 'Nej'}}</span>
        </dd>
        <dt>Totalhistorik</dt>
        <dd><span class="total_history_value">{{value.total_history ? 'Ja' : 'Nej'}}</span></dd>
        <dt>Slet beskrivelse ved anonymisering</dt>
        <dd><span class="clear_description_on_clean_value">{{value.clear_description_on_clean ? 'Ja' : 'Nej'}}</span></dd>
        <dt>Behold bilag ved anonymisering</dt>
        <dd><span class="attachment_keep_on_clean_value">{{value.attachment_keep_on_clean ? 'Ja' : 'Nej'}}</span></dd>
        <dt>Behold dialog ved anonymisering</dt>
        <dd><span class="message_keep_on_clean_value">{{value.message_keep_on_clean ? 'Ja' : 'Nej'}}</span></dd>
        <dt>Behold bevillingsbreve ved anonymisering</dt>
        <dd><span class="keep_approval_letter_value">{{value.keep_approval_letter ? 'Ja' : 'Nej'}}</span></dd>
        <dt>Behold afslagsbreve ved anonymisering</dt>
        <dd><span class="keep_refusal_letter_value">{{value.keep_refusal_letter ? 'Ja' : 'Nej'}}</span></dd>
        <dt>Behold rapporter ved anonymisering</dt>
        <dd><span class="report_keep_on_clean_value">{{value.report_keep_on_clean ? 'Ja' : 'Nej'}}</span></dd>
        <dt>Sletning af inaktive profiler</dt>
        <dd><span class="inactive_profiles_value">{{value.inactive_profiles}}</span> måned(er)</dd>
        <dt>Slet urørte kladder</dt>
        <dd><span class="dead_drafts_value">{{value.dead_drafts}}</span> måned(er)</dd>
        <dt>BCC på stamdataændringer</dt>
        @if (!value.mail?.length) {
          <dd>Ingen.</dd>
        }
        @for (m of value.mail; track m) {
          <dd>{{m}}</dd>
        }
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex=30 class="settings-list">
        <dt>Slet CV efter afslag</dt>
        <dd><span class="newly_refused_value">{{value.newly_refused}}</span> dag(e)</dd>
        <dt>Slet CV efter bevilling</dt>
        <dd><span class="newly_approved_value">{{value.newly_approved}}</span> dag(e)</dd>
        <dt>Anonymisering af tilbagetrukne sager</dt>
        <dd><span class="withdrawn">{{value.withdrawn}}</span> dag(e)</dd>
        <dt>Anonymisering af afviste og flyttede sager</dt>
        <dd><span class="refused_and_moved_value">{{value.refused_and_moved}}</span> dag(e)</dd>
        <dt>Anonymisering af ubehandlede sager</dt>
        <dd><span class="dangling_value">{{value.dangling}}</span> måned(er)</dd>
        <dt>Anonymisering af bevilgede sager</dt>
        <dd><span class="old_approved_value">{{value.old_approved}}</span> år</dd>
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
      <dl fxFlex="30" class="settings-list">
        <dt>Fuldstændig sletning af ansøgninger</dt>
        <dd><span class="purge_enabled">{{value.purge_enabled ? 'Ja' : 'Nej'}}</span></dd>
        @if (value.purge_enabled) {
          <dt>Sletning af ubehandlede, anonymiserede sager</dt>
          <dd><span class="purge_dangling">{{value.purge_dangling}}</span> dag(e)</dd>
          <dt>Sletning af afviste, tilbagetrukne og overførte anonymiserede sager</dt>
          <dd><span class="purge_refused">{{value.purge_refused}}</span> dag(e)</dd>
          <dt>Sletning af bevilgede, anonymiserede sager</dt>
          <dd><span class="purge_approved">{{value.purge_approved}}</span> dag(e)</dd>
          <dt>Sletning af slettede journalnumre</dt>
          <dd><span class="purge_log">{{value.purge_log}}</span> dag(e)</dd>
        }
        <dt>Ryd ansøger historik efter anonymisering</dt>
        <dd><span class="clear_digest_enabled">{{value.clear_digest_enabled ? 'Ja' : 'Nej'}}</span></dd>
        @if (value.clear_digest_enabled) {
          <dt>Ryd ansøger historik efter anonymisering</dt>
          <dd><span class="clear_digest_period">{{ value.clear_digest_period}}</span> måneder</dd>
        }
      </dl>
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" >
        <div fxFlex="30">
          <div fxLayout="column" class="mb-3">
            <mat-checkbox ngDefaultControl class="mb-3" fxFill formControlName="cleaner_disabled" (change)="onCleanerDisabledChanged()">Brug GrantOne som journaliseringssystem.</mat-checkbox>
            @if (isCleanerDisabled) {
              <div class="cleaner-disabled-alert mt-2 p-2">
                <b>!!! OBS !!! OBS !!! OBS !!!</b>
                <div>
                  Når GrantOne bruges som journaliseringssystem bliver ansøgninger <i>ikke</i> anonymiseret.
                </div>
              </div>
            }
          </div>
          <div fxLayout="column" class="mb-3">
            <mat-checkbox ngDefaultControl class="mb-3" fxFill formControlName="total_history">Total historik (historik på anonymiserede sager).</mat-checkbox>
          </div>
          <div fxLayout="column" class="mb-3">
            <mat-checkbox ngDefaultControl class="mb-3" fxFill formControlName="clear_description_on_clean">Slet beskrivelse ved anonymisering.</mat-checkbox>
          </div>
          <div fxLayout="column" class="mb-3">
            <mat-checkbox ngDefaultControl class="mb-3" fxFill formControlName="attachment_keep_on_clean">Behold bilag ved anonymisering</mat-checkbox>
          </div>
          <div fxLayout="column" class="mb-3">
            <mat-checkbox ngDefaultControl class="mb-3" fxFill formControlName="message_keep_on_clean">Behold dialog ved anonymisering</mat-checkbox>
          </div>
          <div fxLayout="column" class="mb-3">
            <mat-checkbox ngDefaultControl class="mb-3" fxFill formControlName="keep_approval_letter">Behold bevillingsbreve ved anonymisering</mat-checkbox>
          </div>
          <div fxLayout="column" class="mb-3">
            <mat-checkbox ngDefaultControl class="mb-3" fxFill formControlName="keep_refusal_letter">Behold afslagsbreve ved anonymisering</mat-checkbox>
          </div>
          <div fxLayout="column" class="mb-3">
            <mat-checkbox ngDefaultControl class="mb-3" fxFill formControlName="report_keep_on_clean">Behold rapporter ved anonymisering</mat-checkbox>
          </div>
          <div fxLayout="column" class="mb-3">
            <label>Sletning af inaktive profiler</label>
            <mat-form-field>
              <input type="number" matInput formControlName="inactive_profiles">
              <span matSuffix>&nbsp;måneder</span>
              <mat-hint>Profiler er inaktive, hvis der ikke er en aktiv sag eller brugeren har været logget ind.</mat-hint>
              @if (form.controls['inactive_profiles'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (form.controls['inactive_profiles'].hasError('min')) {
                <mat-error>Mindst 1 måned.</mat-error>
              }
              @if (form.controls['inactive_profiles'].hasError('max')) {
                <mat-error>Højst 300 måneder (25 år).</mat-error>
              }
            </mat-form-field>
          </div>
          <div fxLayout="column" class="mb-3">
            <label>Sletning af urørte kladder</label>
            <mat-form-field>
              <input type="number" matInput formControlName="dead_drafts">
              <span matSuffix>&nbsp;måneder</span>
              <mat-hint>Kladder er urørte, hvis de ikke er indsendt eller opdateret i en periode.</mat-hint>
              @if (form.controls['dead_drafts'].hasError('required')) {
                <mat-error>Obligatorisk.</mat-error>
              }
              @if (form.controls['dead_drafts'].hasError('min')) {
                <mat-error>Mindst 1 måned.</mat-error>
              }
              @if (form.controls['dead_drafts'].hasError('max')) {
                <mat-error>Højst 300 måneder (25 år).</mat-error>
              }
            </mat-form-field>
          </div>
          <div fxLayout="column" class="mb-3">
            <p>Ved ændring i væsentlige stamdata notificeres nedenstående mails</p>
            @for (_ of mails.controls; track _; let i = $index) {
              <div fxLayout="row" fxLayoutAlign="start center">
                <mat-form-field >
                  <mat-label>E-mail</mat-label>
                  <input
                    type="email"
                    matInput
                    [formControl]="mailAt(i)"
                    />
                </mat-form-field>
                <button
                  mat-icon-button
                  matTooltip="Slet e-mail"
                  (click)="doRemoveMail(i)"
                  ><mat-icon>delete</mat-icon></button>
                </div>
              }
              <div>
                <button
                  mat-flat-button

                  matTooltip="Tilføj e-mail"
                  (click)="doAddMail()"
                >Tilføj e-mail</button>
              </div>
            </div>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div fxFlex="30">
            <div fxLayout="column" class="mb-3">
              <label>CV-oprydning ved afslag</label>
              <mat-form-field>
                <input type="number" matInput formControlName="newly_refused">
                <span matSuffix>&nbsp;dag(e)</span>
                <mat-hint>Sletning af CV efter afsendt afslag.</mat-hint>
                @if (form.controls['newly_refused'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
                @if (form.controls['newly_refused'].hasError('min')) {
                  <mat-error>Mindst 1 dag.</mat-error>
                }
                @if (form.controls['newly_refused'].hasError('max')) {
                  <mat-error>Højst 9.200 dage (25 år).</mat-error>
                }
              </mat-form-field>
            </div>
            <div fxLayout="column" class="mb-3">
              <label>CV-oprydning ved bevilling</label>
              <mat-form-field>
                <input type="number" matInput formControlName="newly_approved">
                <span matSuffix>&nbsp;dag(e)</span>
                <mat-hint>Sletning af CV efter godkendt bevilling.</mat-hint>
                @if (form.controls['newly_approved'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
                @if (form.controls['newly_approved'].hasError('min')) {
                  <mat-error>Mindst 1 dag.</mat-error>
                }
                @if (form.controls['newly_approved'].hasError('max')) {
                  <mat-error>Højst 9.200 dage (25 år).</mat-error>
                }
              </mat-form-field>
            </div>
            <div fxLayout="column" class="mb-3">
              <label>Anonymisering af tilbagetrukne sager</label>
              <mat-form-field>
                <input type="number" matInput formControlName="withdrawn">
                <span matSuffix>&nbsp;dag(e)</span>
                <mat-hint>Ansøgningerne anonymiseres helt efter en karensperiode.</mat-hint>
                @if (form.controls['withdrawn'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
                @if (form.controls['withdrawn'].hasError('min')) {
                  <mat-error>Mindst 1 dag.</mat-error>
                }
                @if (form.controls['withdrawn'].hasError('max')) {
                  <mat-error>Højst 9.200 dage (25 år).</mat-error>
                }
              </mat-form-field>
            </div>
            <div fxLayout="column" class="mb-3">
              <label>Anonymisering af afslag/flytning</label>
              <mat-form-field>
                <input type="number" matInput formControlName="refused_and_moved">
                <span matSuffix>&nbsp;dag(e)</span>
                <mat-hint>Anonymisering af sager efter afslag eller flytning til anden fond.</mat-hint>
                @if (form.controls['refused_and_moved'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
                @if (form.controls['refused_and_moved'].hasError('min')) {
                  <mat-error>Mindst 1 dag.</mat-error>
                }
                @if (form.controls['refused_and_moved'].hasError('max')) {
                  <mat-error>Højst 9.200 dage (25 år).</mat-error>
                }
              </mat-form-field>
            </div>
            <div fxLayout="column" class="mb-3">
              <label>Anonymisering af ubehandlede</label>
              <mat-form-field>
                <input type="number" matInput formControlName="dangling">
                <span matSuffix>&nbsp;måneder</span>
                <mat-hint>Anonymisering af udbehandlere sager.</mat-hint>
                @if (form.controls['dangling'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
                @if (form.controls['dangling'].hasError('min')) {
                  <mat-error>Mindst 1 måned.</mat-error>
                }
                @if (form.controls['dangling'].hasError('max')) {
                  <mat-error>Højst 300 måneder (25 år).</mat-error>
                }
              </mat-form-field>
            </div>
            <div fxLayout="column" class="mb-3">
              <label>Anonymisering af bevilgede</label>
              <mat-form-field>
                <input type="number" matInput formControlName="old_approved">
                <span matSuffix>&nbsp;år</span>
                <mat-hint>Anonymisering af bevilgede sager efter sidste udbetaling.</mat-hint>
                @if (form.controls['old_approved'].hasError('required')) {
                  <mat-error>Obligatorisk.</mat-error>
                }
                @if (form.controls['old_approved'].hasError('min')) {
                  <mat-error>Mindst 5 år pga Skat.</mat-error>
                }
                @if (form.controls['old_approved'].hasError('max')) {
                  <mat-error>Højst 25 år.</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <mat-divider [vertical]="true"></mat-divider>
          <div fxFlex="30">
            <div fxLayout="column" class="mb-3">
              <mat-checkbox ngDefaultControl formControlName="purge_enabled">Fuldstændig sletning af ansøgninger</mat-checkbox>
              @if (purgeEnabled().value) {
                <div class="purge-enabled-alert mt-2 p-2">
                  <b>!!! OBS !!! OBS !!! OBS !!!</b>
                  <div>
                    Når fuldstændig sletning af sager er aktiveret slettes sagerne helt fra databasen,
                    jf. nedenstående opsætning. Det er ikke muligt at genskabe sagerne, når de er slettet.
                  </div>
                </div>
              }
            </div>
            @if (purgeEnabled().value) {
              <div fxLayout="column" class="mb-3">
                <label>Sletning af ubehandlede, anonymiserede sager</label>
                <mat-form-field>
                  <input type="number" matInput formControlName="purge_dangling">
                  <span matSuffix>&nbsp;dag(e)</span>
                  <mat-hint>Endelig sletning af ubehandlede sager efter anonymisering.</mat-hint>
                  @if (form.controls['purge_dangling'].hasError('required')) {
                    <mat-error>Obligatorisk.</mat-error>
                  }
                  @if (form.controls['purge_dangling'].hasError('min')) {
                    <mat-error>Mindst 1 dag.</mat-error>
                  }
                </mat-form-field>
              </div>
            }
            @if (purgeEnabled().value) {
              <div fxLayout="column" class="mb-3">
                <label>Sletning af afviste, anonymiserede sager</label>
                <mat-form-field>
                  <input type="number" matInput formControlName="purge_refused">
                  <span matSuffix>&nbsp;dag(e)</span>
                  <mat-hint>Endelig sletning af afviste sager efter anonymisering.</mat-hint>
                  @if (form.controls['purge_refused'].hasError('required')) {
                    <mat-error>Obligatorisk.</mat-error>
                  }
                  @if (form.controls['purge_refused'].hasError('min')) {
                    <mat-error>Mindst 1 dag.</mat-error>
                  }
                </mat-form-field>
              </div>
            }
            @if (purgeEnabled().value) {
              <div fxLayout="column" class="mb-3">
                <label>Sletning af bevilgede, anonymiserede sager</label>
                <mat-form-field>
                  <input type="number" matInput formControlName="purge_approved">
                  <span matSuffix>&nbsp;dage</span>
                  <mat-hint>Endelig sletning af bevilgede sager efter anonymisering.</mat-hint>
                  @if (form.controls['purge_approved'].hasError('required')) {
                    <mat-error>Obligatorisk.</mat-error>
                  }
                  @if (form.controls['purge_approved'].hasError('min')) {
                    <mat-error>Mindst 1 dag.</mat-error>
                  }
                </mat-form-field>
              </div>
            }
            @if (purgeEnabled().value) {
              <div fxLayout="column" class="mb-3">
                <label>Slettelog levetid</label>
                <mat-form-field>
                  <input type="number" matInput formControlName="purge_log">
                  <span matSuffix>&nbsp;dage</span>
                  <mat-hint>Hvor mange år journalnumre gemmes efter sletningen.</mat-hint>
                  @if (form.controls['purge_log'].hasError('required')) {
                    <mat-error>Obligatorisk.</mat-error>
                  }
                  @if (form.controls['purge_log'].hasError('min')) {
                    <mat-error>Mindst 1 dag.</mat-error>
                  }
                </mat-form-field>
              </div>
            }
            <div fxLayout="column" class="mb-3">
              <mat-checkbox ngDefaultControl formControlName="clear_digest_enabled">Ryd ansøger historik efter anonymisering</mat-checkbox>
            </div>
            @if (clearDigestEnabled().value) {
              <div fxLayout="column" class="mb-3">
                <label>Slettelog levetid</label>
                <mat-form-field>
                  <input type="number" matInput formControlName="clear_digest_period">
                  <span matSuffix>&nbsp;måneder</span>
                  <mat-hint>Hvor mange måneder efter anonymisering før historikken rydes.</mat-hint>
                  @if (form.controls['clear_digest_period'].hasError('required')) {
                    <mat-error>Obligatorisk.</mat-error>
                  }
                  @if (form.controls['clear_digest_period'].hasError('min')) {
                    <mat-error>Mindst 1 måned.</mat-error>
                  }
                </mat-form-field>
              </div>
            }
          </div>
        </div>
      </form>
    }
    <mat-action-row>
      @if (form.disabled) {
        <button mat-flat-button class="action-edit" (click)="doEdit()">Rediger</button>
      }
      @if (form.enabled) {
        <div>
          <button mat-stroked-button class="action-cancel" (click)="doCancel()">Fortryd</button>
          <button mat-flat-button class="action-save" (click)="doSave()" [disabled]="form.invalid">Gem</button>
        </div>
      }
    </mat-action-row>
  </mat-expansion-panel>
